<template>
    <div class="rightContent">
        <div class="rightTitle clear">
            <div class="colorLump"></div>
            <div class="title">财务信息</div>
        </div>
        <div class="main orgFinance">
            <div class="rightBox clear">
                <div class="leftFinance">
                    <div class="topHeader">发票信息</div>
                    <div class="FinanceInfo">
                        <div class="item clear">
                            <div>发票类型</div>
                            <div>：</div>
                            <div>{{data.billType }}</div>
                        </div>
                        <div class="item clear">
                            <div>发票抬头</div>
                            <div>：</div>
                            <div>{{data.billName }}</div>
                        </div>
                        <div class="item specialItem clear">
                            <div>单位税号</div>
                            <div>：</div>
                            <div>{{data.taxpayerNum }}</div>
                        </div>
                        <div class="item clear">
                            <div>注册地址</div>
                            <div>：</div>
                            <div>{{data.billAddress }}</div>
                        </div>
                        <div class="item clear">
                            <div>注册电话</div>
                            <div>：</div>
                            <div>{{data.billPhone }}</div>
                        </div>
                        <div class="item clear">
                            <div>开户银行</div>
                            <div>：</div>
                            <div>{{data.billBank }}</div>
                        </div>
                        <div class="item clear">
                            <div>银行账号</div>
                            <div>：</div>
                            <div>{{data.billBankAccount }}</div>
                        </div>
                    </div>
                </div>
                <div class="rightFinance">
                    <div class="topHeader longTopHeader">结算账户
                    </div>
                    <div class="FinanceInfo">
                        <div class="item clear">
                            <div>账户名</div>
                            <div>：</div>
                            <div>{{data.balanceAccount }}</div>
                        </div>
                        <div class="item clear">
                            <div>开户行</div>
                            <div>：</div>
                            <div>{{data.balanceBank }}</div>
                        </div>
                        <div class="item clear">
                            <div>银行账号</div>
                            <div>：</div>
                            <div>{{data.balanceBankAccount }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { getJgInfo } from '../../server/jigou/orgCenter'
import { ref, reactive } from 'vue'

const data = ref([])

async function getInfo(){
    let res = await getJgInfo()
    if( res != false ){
        console.log(res.orgInfo);
        data.value = JSON.parse(JSON.stringify(res.orgInfo))
        console.log(data.value,data.value.balanceBankAccount);
    }
}
getInfo() 
</script>